module.exports = __webpack_public_path__ + "img/default_service.0180405f.jpg";